'use client'

import PropTypes from 'prop-types'
import { WizardSidebarTimelineItem } from '@repo/ui/WizardSidebarTimelineItem'
import MUIStack from '@mui/material/Stack'
import MUIButton from '@mui/material/Button'

export const WizardSidebarTimeline = ({
  wizardConfig = [],
  handleStageButtonClick,
  handleStepButtonClick,
  currentStageId,
  currentStepId
}) => {
  return wizardConfig?.map((stage, index) => {
    return (
      <MUIStack
        data-testid="WizardSidebarTimeline"
        key={stage.stageId}
        sx={{
          height: currentStageId === stage.stageId ? '100%' : '40px',
          minHeight: '40px',
          overflow: 'hidden',
          transition: 'all 500ms',
          marginTop: index === 0 ? '24px' : 0,
          marginBottom: '4px'
        }}
      >
        {wizardConfig.length > 1 && (
          <MUIButton
            onClick={() => handleStageButtonClick(stage.stageId)}
            sx={{
              justifyContent: 'flex-start',
              color: currentStageId === stage.stageId ? 'text.primary' : 'text.secondary',
              fontFamily: 'Poppins',
              padding: '0',
              textAlign: 'left',
              height: '40px',
              minHeight: '40px',
              '&:hover': {
                background: 'transparent'
              }
            }}
          >
            0{index + 1} {stage.stageLabel}
          </MUIButton>
        )}
        <div style={{ width: '100%', marginTop: '8px' }}>
          {stage?.steps?.map((step, index) => (
            <WizardSidebarTimelineItem
              key={`${step.stepLabel}-${index}`}
              step={step}
              isFirst={index === 0}
              onClick={handleStepButtonClick}
              isCurrent={currentStageId === stage.stageId && currentStepId === step.stepId}
              uniqueId={step.uniqueId}
            />
          ))}
        </div>
      </MUIStack>
    )
  })
}

WizardSidebarTimeline.propTypes = {
  wizardConfig: PropTypes.array,
  handleStageButtonClick: PropTypes.func,
  handleStepButtonClick: PropTypes.func,
  currentStageId: PropTypes.string,
  currentStepId: PropTypes.string,
  wizardId: PropTypes.string
}